
import React, { useEffect, useState, forwardRef, useRef } from "react";
// import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from "react-router-dom";
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, Container, Popover,
    TablePagination, Typography, InputAdornment, IconButton, DialogContent, Divider, Snackbar, Slider, Avatar
} from '@mui/material';
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import { SearchOutlined } from '@mui/icons-material';
// import { downloadExcel } from 'react-export-table-to-excel';
import BackBtn from "../../reusableComponent/BackBtn";
import { useDispatch, useSelector } from "react-redux";
import { editDeleteCNS, editDeleteUnit, getCNSList, getUnitList } from "../../../actions/actions";
import styles from '.././../../styles.module.css';
import {
    PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, LineChart, Line,
    CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart, Scatter, Sector
} from 'recharts';
import PurchaseHome from "./PurchaseHome";
import Breadcrumb from "../../reusableComponent/Breadcrumb";
// ----------pieChart------------
const datap = [
    { name: 'Group A', value: 400 },
    { name: 'Group B', value: 300 },
    { name: 'Group C', value: 300 },
    { name: 'Group D', value: 200 },
    { name: 'Group E', value: 278 },
    { name: 'Group F', value: 189 },
];
// -------line bar-------
const linedata = [
    {
        name: 'Supplier A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: 'Supplier B',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: 'Supplier C',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: 'Supplier D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Supplier E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Supplier F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Supplier G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];

// ------bar chart

const databar = [
    {
        name: 'Supplier A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: 'Supplier B',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: 'Supplier C',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: 'Supplier D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Supplier E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Supplier F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Supplier G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];

// ----------
const data1 = [
    { name: 'Group B', value: 500 },
    { name: 'Group A', value: 100 },

];
const data2 = [
    { name: 'Group B', value: 2200 },
    { name: 'Group D', value: 1100 },
];
const data3 = [
    { name: 'Group A', value: 900 },
    { name: 'Group B', value: 2200 },

];
const COLORS1 = ['#0088FE', '#C0C0C0', '#FF8042'];
const COLORS2 = ['#00C49F', '#C0C0C0', '#FF8042'];
const COLORS3 = ['#C0C0C0', '#FF8042'];
function PurchaseDashboard() {


    const dispatch = useDispatch();

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const rows = useSelector(state => state.CNS.CNS)
    const fetchData = () => {
        dispatch(getCNSList({financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'Customer' }))
    };
    useEffect(() => {
        fetchData()
    }, []);
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.CNS.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                // setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' });
                fetchData();
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);




    return (
        <>
          <Breadcrumb
                routeSegments={[
                    { name: 'Purchase', },
                ]}
            />
        <PurchaseHome/>
            <Paper className={`${styles.gradient_banner}`}>
                <Box sx={{ justifyContent: 'center', }}>
                    {/* <Typography className={`${styles.page_title}`} style={{ fontSize: '30px', fontWeight: 'bold', textAlign: 'center' }}> <span style={{ borderBottom: '5px solid #14516f' }}> Purchase Performance Dashboard </span></Typography> */}
                    <br />
                </Box>
                <Box style={{ margin: '18px', }}>
                    <Grid container spacing={2} sx={{ backgroundColor: '#ffffff', ml: 0, paddingRight: '14px' }}>
                        <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRight: '1px solid #c0c0c0' }}>
                            <Box >
                                <Grid container spacing={1}>
                                    <Grid item xs={4} md={4}>
                                        <PieChart width={140} height={120} >
                                            <Pie
                                                data={data1}
                                                cx={60}
                                                cy={55}
                                                innerRadius={40}
                                                outerRadius={50}
                                                fill="#8884d8"
                                                paddingAngle={0}
                                                dataKey="value"
                                            >
                                                {data1.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS1[index % COLORS1.length]} />
                                                ))}
                                            </Pie>
                                            <text x={60} y={55} textAnchor="middle" dominantBaseline="middle" fontSize="12">
                                                SUPPLIERS
                                            </text>
                                        </PieChart>
                                    </Grid>
                                    <Grid item xs={4} md={4}>
                                        <PieChart width={140} height={120} >
                                            <Pie
                                                data={data2}
                                                cx={60}
                                                cy={55}
                                                innerRadius={40}
                                                outerRadius={50}
                                                fill="#8884d8"
                                                paddingAngle={5}
                                                dataKey="value"
                                            >
                                                {data2.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS2[index % COLORS2.length]} />
                                                ))}
                                            </Pie>
                                            <text x={60} y={55} textAnchor="middle" dominantBaseline="middle" fontSize="12">
                                                CONTRACTED
                                            </text>
                                        </PieChart>
                                    </Grid>
                                    <Grid item xs={4} md={4}>
                                        <PieChart width={140} height={120} >
                                            <Pie
                                                data={data3}
                                                cx={60}
                                                cy={55}
                                                innerRadius={40}
                                                outerRadius={50}
                                                fill="#8884d8"
                                                paddingAngle={0}
                                                dataKey="value"
                                            >
                                                {data3.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS3[index % COLORS3.length]} />
                                                ))}
                                            </Pie>
                                            <Pie
                                                data={data3}
                                                cx={60}
                                                cy={55}
                                                innerRadius={40}
                                                outerRadius={50}
                                                fill="#8884d8"
                                                paddingAngle={0}
                                                dataKey="value"
                                            >
                                                {data3.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS3[index % COLORS3.length]} />
                                                ))}
                                            </Pie>
                                            <text x={60} y={55} textAnchor="middle" dominantBaseline="middle" fontSize="12">
                                                UNLISTED
                                            </text>
                                        </PieChart>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid item xs={6} md={3} sx={{ borderRight: '1px solid #c0c0c0' }} >
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.purchase_home_card}`}>
                                        <Typography className={`${styles.sale_home_lable}`} style={{ fontWeight: 'bold' }}>Gold Partner</Typography>
                                        <Typography className={`${styles.sale_home_lable}`}>16 %</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.purchase_home_card2}`}>
                                        <Typography className={`${styles.sale_home_lable}`} style={{ fontWeight: 'bold' }}>Silver Partner</Typography>
                                        <Typography className={`${styles.sale_home_lable}`}>26 %</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.purchase_home_card3}`}>
                                        <Typography className={`${styles.sale_home_lable}`} style={{ fontWeight: 'bold' }}>Bronze Partner</Typography>
                                        <Typography className={`${styles.sale_home_lable}`}>46 %</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} md={3} >
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.purchase_home_card}`}>
                                        <Typography className={`${styles.sale_home_lable}`} style={{ fontSize: '16px', fontWeight: 'bold' }}>Total Spending</Typography>
                                        <Typography className={`${styles.sale_home_lable}`}>6 %</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.purchase_home_card2}`}>
                                        <Typography className={`${styles.sale_home_lable}`} style={{ fontSize: '16px', fontWeight: 'bold' }}>Profit Margin</Typography>
                                        <Typography className={`${styles.sale_home_lable}`}>6 %</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.purchase_home_card3}`}>
                                        {/* <Typography className={`${styles.sale_home_lable}`} style={{ fontSize: '16px', fontWeight: 'bold' }}>Profit Margin</Typography> */}
                                        <Slider
                                            disabled={false}
                                            marks={false}
                                            max={100}
                                            min={0}
                                            size="small"
                                            valueLabelDisplay="on"
                                        />
                                    </Box>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                    <br />
                    <Grid container spacing={2} >
                        <Grid item xs={12} md={8} >
                            <Grid container spacing={1} sx={{ backgroundColor: '#ffffff' }}>
                                <Grid item xs={12} md={12}>
                                    <Typography>Expense Summary </Typography>
                                    <BarChart
                                        width={700}
                                        height={210}
                                        data={databar}
                                        margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                    >
                                        {/* <CartesianGrid strokeDasharray="3 3" /> */}
                                        <XAxis dataKey="name" />
                                        {/* <YAxis /> */}
                                        <Tooltip />
                                        <Legend />
                                        <Bar dataKey="pv" fill="#8884d8" />
                                        <Bar dataKey="uv" fill="#82ca9d" />
                                    </BarChart>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12} >
                                    <LineChart style={{ backgroundColor: '#ffffff' }}
                                        width={420}
                                        height={150}
                                        data={linedata}
                                        margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="name" />
                                        <YAxis />
                                        <Tooltip />
                                        <Legend />
                                        <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
                                        <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
                                    </LineChart>
                                </Grid>

                                <Grid item xs={12} md={12} >
                                    <PieChart width={420} height={100} style={{ backgroundColor: '#ffffff' }}>
                                        <Pie
                                            dataKey="value"
                                            startAngle={180}
                                            endAngle={0}
                                            data={datap}
                                            cx="50%"
                                            cy="90%"
                                            outerRadius={80}
                                            fill="#8884d8"
                                            label
                                        />
                                    </PieChart>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </>
    )
}

export default PurchaseDashboard